import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Planning, PlanningCategorieCours, TypeCours} from '../../../suaps/common/services/planning/plannig.model';
import {Individu, PubSubService} from '@Common/core/services';
import {SubSink} from '@Common/core/utils/subsink';
import {
  StateSubscription,
  Subscription,
  SubscriptionCategorieCours
} from '../../../suaps/common/services/subscription/subscription.model';
import {SubscriptionService} from '../../../suaps/common/services/subscription/subscription.service';
import {EnseignantService} from '../../../suaps/common/services/enseignant/enseignant.service';
import {Campagne} from '../../../suaps/common/services/campagne/campagne.model';
import {PlanningFOService} from '../../../suaps/common/services/planning/planning-fo.service';
import {finalize} from 'rxjs/operators';
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";
import * as FileSaver from "file-saver";
import {AttachmentService} from "@Common/widgets/general/attachments";

@Component({
  selector: 'app-activity-detail',
  templateUrl: './activity-detail.component.html',
  styleUrls: ['./activity-detail.component.scss'],
})
export class ActivityDetailComponent implements OnInit {
  _activity: Planning;
  @Input() set activity(value: Planning) {
      this._getActivity(value);
  }
  get activity() {
    return this._activity;
  }
  @Input() connecte: Individu;
  @Input() campagne: Campagne;
  @Output() goList = new EventEmitter<Boolean>();
  typeCours = TypeCours;
  subSink = new SubSink();
  stateSubscription = StateSubscription;
  subscription: Subscription = <Subscription>{id:0};
  mySubscriptions: Subscription[] = [];
  extraParams: Map<string, string> = new Map<string, string>();
  subscriptionOk = false;
  subscriptionCategorieCours = SubscriptionCategorieCours;
  planningCategorieCours = PlanningCategorieCours;
  choixCategorieCours = null;

  constructor(public pubSubSvc: PubSubService,
              public planningSvc: PlanningFOService,
              public ensSvc: EnseignantService,
              public subscriptionSvc: SubscriptionService,
              private pubSvc: PubSubService,
              private attchmentSvc: AttachmentService,) { }

  ngOnInit(): void {
    this._getMySubscriptions();
  }
  close(): void {
    this.goList.emit(true);
  }

  public getNbSubscriptions(activity: Planning): number {
    return activity.subscriptions_count;
  }

  isLocked(activity: Planning): boolean {
    return activity.is_locked;
  }

  canSubscribe(subscription: Subscription): boolean {
    return (this.choixCategorieCours > 0
      && (subscription.id > 0 ? subscription?.state_subscription === this.stateSubscription.canceled : true)
      && (this.mySubscriptions.length < this.campagne.max_inscriptions || this._activity.type_cours === this.typeCours.stage));
  }
  canUnsubscribe(subscription: Subscription): boolean {
    if (subscription.id > 0) {
      return subscription.state_subscription === this.stateSubscription.waiting;
    }
    return false;
  }

  subscribe(): void {
    this.pubSvc.publish('loading', true);
    this.subscription.member = this.connecte.username;
    this.subscription.planning = this.activity.id;
    this.subscription.state_subscription = this.stateSubscription.waiting;
    this.subscription.categorie_cours = this.choixCategorieCours;
    this.subSink.sink = this.subscriptionSvc
      .updateOrcreate(this.subscription)
      .pipe(finalize(() => this.pubSvc.publish('loading', false)))
      .subscribe((_data) => {
        this.subscription = _data;
        this._getActivity(this.activity);
        this.subscriptionOk = true;
        this.choixCategorieCours = null;
    });
  }

  unSubscribe(): void {
    this.subscription.state_subscription = this.stateSubscription.canceled;
    this.subscription.categorie_cours = null;
    this._setCategorieCours();
    this.subSink.sink = this.subscriptionSvc
      .update(this.subscription)
      .subscribe(() => {
        this._getActivity(this.activity);
        this._getMySubscriptions();
    });
  }

  displayState(state: number): string {
    return this.subscriptionSvc.displayState(state);
  }

  displayCategorieCours(): string {
    if (this.activity.type_cours === this.typeCours.stage) {
      if (this.activity.categorie_cours === this.planningCategorieCours.ec_libre) {
        return 'Intensif EC';
      }
      if (this.activity.categorie_cours === this.planningCategorieCours.les_deux) {
        return 'Intensif EC et loisir';
      }
    }
    return this.activity.categorie_cours_label;
  }

  registrationsOpened(campagne: Campagne): boolean {
    const today = new Date();
    const date_debut_inscriptions = new Date(campagne.date_debut);
    const date_fin_inscriptions = new Date(campagne.date_fin);
    return (today >= date_debut_inscriptions && today <= date_fin_inscriptions);
  }

  private _getMySubscription(): void {
    this.subscription = this.subscriptionSvc.getMySubscription(this.activity.subscriptions_obj, this.connecte);
  }

  private _getMySubscriptions(): void {
    if (!this.campagne || !this.connecte) {
      return;
    }
    this.pubSvc.publish('loading', true);
    this.extraParams.clear();
    this.extraParams.set('planning__campagne', this.campagne.id.toString());
    this.extraParams.set('member', this.connecte.username.toString());
    this.subSink.sink = this.subscriptionSvc
      .listAllItems(this.extraParams)
      .pipe(finalize(() => this.pubSvc.publish('loading', false)))
      .subscribe((_subs) => {
        this.mySubscriptions = _subs.list.filter((subs) =>
          (subs.state_subscription === this.stateSubscription.waiting ||
            subs.state_subscription === this.stateSubscription.accepted)
          && subs.planning_obj.type_cours === this.typeCours.cours);
      });
  }

  private _setCategorieCours(): void {
    this.choixCategorieCours = null;
    if (this.activity.categorie_cours === this.planningCategorieCours.loisir ||
      this.activity.categorie_cours === this.planningCategorieCours.ec_libre) {
      this.choixCategorieCours = this.activity.categorie_cours;
    }
    if (this.subscription?.categorie_cours) {
      this.choixCategorieCours = this.subscription?.categorie_cours;
    }
  }
  /**
   * Force la recharge du planning pour avoir le nombre d'inscrits réels entre le connecté et les autres étudiants connectés
   * @param {Planning} value
   */
  _getActivity(value: Planning) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.planningSvc
      .get(value.id)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(_planning => {
        this._activity = _planning;
        this._getMySubscription();
        this._setCategorieCours();
      });
  }

  downloadFile(file: AttachmentModel) {
    const fileName = file?.filename_origin || file.filename;
    this.subSink.sink = this.attchmentSvc.download(file).subscribe(v => FileSaver.saveAs(v, fileName));
  }

}
